import React from "react";
import SearchField from "../SearchField";

export default function AttendanceSummaryBar({
  expected,
  checkedIn,
  remaining,
  search,
  onSearchChange,
  onExportCsv,
}) {
  return (
    <div className="space-y-3" data-testid="class-dash-summary">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 font-ui text-[13px] font-medium text-ink/80">
        <span data-testid="class-dash-stat-expected">Expected: {expected}</span>
        <span className="text-ink/30" aria-hidden>·</span>
        <span data-testid="class-dash-stat-checked-in">Checked in: {checkedIn}</span>
        <span className="text-ink/30" aria-hidden>·</span>
        <span data-testid="class-dash-stat-remaining">Remaining: {remaining}</span>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <SearchField
          value={search}
          onChange={onSearchChange}
          placeholder="Search student name"
          label="Search student name"
          testId="class-dash-search"
          clearTestId="class-dash-search-clear"
          className="flex-1 min-w-0"
        />
        <button
          type="button"
          onClick={onExportCsv}
          className="inline-flex items-center justify-center min-h-[44px] px-1 font-ui text-[14px] font-semibold text-plum underline underline-offset-2 shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
          data-testid="class-dash-export-csv"
        >
          Export CSV
        </button>
      </div>
    </div>
  );
}
